import React from 'react';
import { WarningOutlined } from "@ant-design/icons";

const Card = ({ children, title, notification }) => {
    return (
        <div className='card'>
            <div>
                <div className='card-title'>
                    {title}
                </div>

                <div>
                    {children}
                </div>
            </div>
            {notification && (
                <div className='error-notification'>
                    <WarningOutlined style={{ color: '#FF5252', marginRight: '16px' }} />
                    Դիմումը չի կարող մշակվել։ Ստեղծեք նոր դիմում։
                </div>
            )}
        </div>
    )
};

export const CardItem = ({name, value, style}) => {
    return <div className='card-item' style={style}>
        <div className='card-item-name'>{name}</div>
        <div className='card-item-value'>{value}</div>
    </div>;
};

export default Card;